import { InstanceScreen } from 'component/navigation/instance';
import { useLocalSearchParams } from 'expo-router';

export default function LoginIndexScreen() {
    const { action } = useLocalSearchParams<'/[siloKey]/login/one'>();
    return <InstanceScreen params={{ action }} />;
}
